import { SortValues } from '@business/gql/graphql';
import { ReadonlyURLSearchParams } from 'next/navigation';

type Variables = {
  searchParams: ReadonlyURLSearchParams;
  sort: SortValues;
};
export default function getSortAsQueryString(args: Variables) {
  const { searchParams, sort } = args;

  const newSearchParams = new URLSearchParams(searchParams.toString());

  newSearchParams.set('sort', sort);

  return newSearchParams.toString();
}
